import type { ReactElement } from "react";

import { cx, styled } from "simplydo/react/styled";

import { StyledDropdownMenu } from "./Dropdown.styles";
import type { DropdownMenuProps } from "./Dropdown.types";
import { useDropdownContext } from "./DropdownContext";

const DropdownMenuComponent = (props: DropdownMenuProps): ReactElement => {
  const { children, className, style } = props;

  const ctx = useDropdownContext();
  const isOpen = ctx?.open ?? true;

  return (
    <StyledDropdownMenu
      className={cx(className)}
      style={style}
      $open={isOpen}
      role={ctx ? undefined : "listbox"}
    >
      {children}
    </StyledDropdownMenu>
  );
};

export const DropdownMenu = styled(DropdownMenuComponent)``;
